<script setup>
import { computed } from 'vue';
import { humanized } from '@/utils/Dates.js';
import { useI18n } from 'vue-i18n';

const props = defineProps({
    timestamp: String,
});

const { locale } = useI18n();

const ellapsedTime = computed(() => {
    return humanized(props.timestamp, locale.value);
});
</script>

<template>
    <span class="humanized-date">{{ ellapsedTime }}</span>
</template>